module.exports = __webpack_public_path__ + "img/arrow.b32e22bc.svg";